export default __webpack_public_path__ + "static/media/icon_2.c1314b5a.svg";